import React, { useState } from "react";
import { ProColumns } from "@ant-design/pro-table/es/typing";
import clsx from "clsx";
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import Table from "../../../../../Common/Table";
import { CHART_PALETTE as COLORS } from "../../../chartPalette";

interface RowData {
  id: number;
  key: number;
  segment: string;
  label: number;
  value: string;
  percent: string;
  description: string;
  color: string;
}

const segments = [
  "New users",
  "Active users",
  "Inactive users",
  "Premium users",
  "Guests",
  "Trial users",
  "Enterprise users",
];

const tableData: RowData[] = Array.from({ length: 85 }).map((_, i) => {
  const value = Math.floor(Math.random() * 500) + 50;
  const percent = Math.floor(Math.random() * 40) + 1;

  return {
    id: i + 1,
    key: i + 1,
    segment: segments[i % segments.length],
    label: value,
    value: value.toString(),
    percent: `${percent}%`,
    description: `Description for ${segments[i % segments.length]}`,
    color: COLORS[i % COLORS.length],
  };
});

export default function PieChartView(): React.ReactNode | null {
  const [, setSearchParams] = useSearchParams();
  const [tableKey, setTableKey] = useState<number>(() => Date.now());
  const { t, i18n } = useTranslation();

  const columns: ProColumns<RowData>[] = [
    {
      title: t("pages.dashboard.analytics.segment"),
      dataIndex: "segment",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              backgroundColor: record.color,
              display: "inline-block",
            }}
          />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: t("pages.dashboard.analytics.label"),
      dataIndex: "label",
      width: 100,
    },
    {
      title: t("pages.dashboard.analytics.value"),
      dataIndex: "value",
      width: 100,
    },
    {
      title: t("pages.dashboard.analytics.percentOfTotal"),
      dataIndex: "percent",
      width: 120,
    },
    {
      title: t("pages.dashboard.analytics.description"),
      dataIndex: "description",
      width: 200,
      render: (text) => <span style={{ color: "var(--ant-color-text-secondary)" }}>{text}</span>,
    },
  ];
  // const tableRequest = (
  //   {
  //     current,
  //     pageSize,
  //     ...args
  //   }: Record<string, string> & {
  //     pageSize?: number | undefined;
  //     current?: number | undefined;
  //     keyword?: string | undefined;
  //   },
  //   sorter: Record<string, SortOrder>,
  // ): Promise<Partial<RequestData<???>>> => {
  //   const newParams = queryFilterParams({
  //     page: current ? `${current}` : '1',
  //     pageSize: pageSize ? `${pageSize}` : '10',
  //     ...args,
  //     ...getSorterParams(sorter),
  //   });

  //   setSearchParams({ ...args, ...getSorterParams(sorter) }, { replace: true });

  //   return ????.fetch({
  //     ...newParams,
  //     name: newParams?.name || undefined,
  //   }).then((response) => {
  //     if (response) {
  //       const { data, total } = response;

  //       return ({
  //         data: (data || []).map(((item) => ({
  //           ...item,
  //           key: item.id,
  //         }))),
  //         success: true,
  //         total,
  //       });
  //     }

  //     return ({ data: [], success: false, total: 0 });
  //   });
  // };

  return (
    <Table<RowData>
      key={`${tableKey}-${i18n.language}`}
      resetKey={() => setTableKey(Date.now())}
      className={clsx("transparent")}
      // headerTitle={t('pages.users.tableName')}
      toolBarRender={false}
      // request={tableRequest}
      dataSource={tableData}
      columns={columns}
      search={{
        style: {
          display: "none",
        },
      }}
      // A summary of the chart above it rather than a standard table — it has
      // no filtering, no paging and a fixed set of columns, so it opts out of
      // the toolbar controls the shared Table gives everything else.
      options={{
        search: false,
        reload: false,
        setting: false,
      }}
      pagination={{
        defaultPageSize: 10,
        // No jump-to-page in a modal: the list is short and the field only
        // crowds a dialog that is already narrow.
        showQuickJumper: false,
      }}
      columnsState={{
        persistenceKey: "pro-table-users",
        persistenceType: "localStorage",
      }}
    />
  );
}
